import { Injectable, inject } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Platform } from "@ionic/angular";

import { ToastService } from "../toast/toast.service";

@Injectable({ providedIn: "root" })
export class UtilsService {
  private readonly toast = inject(ToastService);
  private readonly translate = inject(TranslateService);
  private readonly platform = inject(Platform);
  constructor() {}

  public validateForm(form: FormGroup): void {
    form.markAllAsTouched();
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      control.setValue(control.value);
      control.markAsDirty();
    });
  }

  public isAppleDevice(): boolean {
    return this.platform.is("ios") ||
           this.platform.is("ipad") ||
           /Mac|Macintosh|MacIntel/.test(navigator.platform) ||
           navigator.userAgent.includes('Mac');
  }

  public isAndroidDevice(): boolean {
    return this.platform.is("android");
  }

  public isMobileDevice(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
  }

  public isInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  }

  public isTouchScreen(): boolean {
    return ('ontouchstart' in window) ||
         (navigator.maxTouchPoints > 0) ||
         ((navigator as any).msMaxTouchPoints as number || 0) > 0;
  }

  public copyToClipboard(value: string, id?: string, texts?: { titleKey: string; messageKey: string }): void {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        this.toast.show(
          {
            title: this.translate.instant(texts?.titleKey || "TOAST.COPY_TO_CLIPBOARD.SUCCESS.TITLE"),
            message: this.translate.instant(texts?.messageKey || "TOAST.COPY_TO_CLIPBOARD.SUCCESS.MESSAGE"),
          },
          id,
        );
      })
      .catch(() => {
        this.toast.show(
          {
            title: this.translate.instant("TOAST.COPY_TO_CLIPBOARD.ERROR.TITLE"),
            message: this.translate.instant("TOAST.COPY_TO_CLIPBOARD.ERROR.MESSAGE"),
          },
          id,
        );
      });
  }
}
